import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, JwTokenModel, UserModel } from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";



@Component({
  selector: 'app-knowledge-component',
  templateUrl: './knowledge.component.html',
  styleUrl: './knowledge.component.css',
  standalone: false
})
export class KnowledgeComponent implements OnInit, AfterViewInit {
  


  
  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService) {
  }


  ngOnInit(): void {

    
    this.route.queryParams.subscribe(params => {
      let userId = +params['userId'];
    });


    this.authService.checkIfAutorized([ArkUserType.Marketing, ArkUserType.Admin]);
  
  }

  ngAfterViewInit(): void {
    

    
    
  }

  

}
